﻿import * as React from 'react';
import { BaseResolver } from './base-resolver';

interface ResolverState {
    layerName: string;
    unpackSvg: boolean;
}

export class Resolver_ImportToLayer extends BaseResolver {
    public id: "resolver_importtolayer";

    private state: ResolverState = {
        layerName: "",
        unpackSvg: true,
    };

    public constructor(private resolveMode: "Open" | "Import", private initialLayerName: string, private updateTargetLayerName: (newValue: string) => void) {
        super();

        this.resolveOrder = 1000; // We want this to actually resolve last due to unpacking.
        this.component = (
            <Resolver_ImportToLayer_Element initialLayerName={this.initialLayerName} onChange={v => this.onUpdate(v)} />
        );
    }

    public needResolution(): boolean {
        return this.resolveMode === "Import";
    }

    public resolveSvg(svgContainer: HTMLTemplateElement) {
        if (this.state.unpackSvg) {
            const root = svgContainer.firstElementChild;

            // TODO: How to handle if the SVG has a transform on it?
            //       Perhaps first group it, add it to the canvas, then call SVGEdit's ungroup on the group, 
            //       which usually unpacks transforms without issue?

            while (root.children.length > 0) {
                const child = root.children[0];

                if (child.tagName.toLowerCase() === "title" || child.tagName.toLowerCase() === "defs") {
                    root.removeChild(child);
                    continue;
                }

                svgContainer.appendChild(child);
            }

            svgContainer.removeChild(root);
        }
    }

    private onUpdate(newValues: ResolverState | { [key: string]: any }) {
        for (const key in newValues) {
            if (key === "layerName") {
                this.updateTargetLayerName(newValues[key]);
            }
        }

        this.state = {
            ...this.state,
            ...newValues
        }
    }
}


interface Props {
    initialLayerName: string;
    onChange(newValues: { [key: string]: any }): void;
}

const Resolver_ImportToLayer_Element: React.FC<Props> = ({ initialLayerName, onChange }) => {
    const [layerName, setLayerName] = React.useState(initialLayerName);
    const [unpackSvg, setUnpackSvg] = React.useState(true);

    const doSetLayerName = (newValue: string) => {
        onChange({ layerName: newValue });
        setLayerName(newValue);
    }

    const doSetUnpackSvg = (newValue: boolean) => {
        onChange({ unpackSvg: newValue });
        setUnpackSvg(newValue);
    }

    return (
        <fieldset>
            <legend>New Layer Settings</legend>

            <div className="row g-3 align-items-center">
                <div className="col-auto">
                    <label htmlFor="importresolver_newlayername" className="col-form-label">Layer Name</label>
                </div>
                <div className="col-auto">
                    <input type="text" id="importresolver_newlayername" className="form-control" aria-describedby="importresolver_newlayername__help" value={layerName} onChange={e => doSetLayerName(e.target.value)} />
                </div>
                <div className="col-auto">
                    <span id="importresolver_newlayername__help" className="form-text">
                        Used for the newly imported layer name.
                    </span>
                </div>
            </div>

            {/*
            <div className="row g-3 align-items-center">
                <div className="col-auto">
                    <label htmlFor="importresolver_unpacksvg" className="col-form-label">Unpack SVG</label>
                </div>
                <div className="col-auto">
                    <input type="checkbox" id="importresolver_unpacksvg" className="form-check-input" aria-describedby="importresolver_unpacksvg__help" checked={unpackSvg} onChange={e => doSetUnpackSvg(e.target.checked)} />
                </div>
                <div className="col-auto">
                    <span id="importresolver_unpacksvg__help" className="form-text">
                        <p>If ticked, the primary &lt;svg&gt; element for the imported file will be discarded.</p>
                        <p>This will allow the contents to be edited, but may affect how some elements initially appear.</p>
                    </span>
                </div>
            </div>
            */}
        </fieldset>
    );
}

